export const createClearButton = (): HTMLButtonElement => {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'tt-input-clear-btn';

  const svg = createClearButtonSvg();
  button.appendChild(svg);

  return button;
};

const createClearButtonSvg = (): SVGElement => {
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('width', '16');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('height', '16');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');

  const path = document.createElementNS(svgNS, 'path');
  path.setAttribute('d', 'M18 6L6 18M6 6L18 18');
  path.setAttribute('stroke-width', '2');
  path.setAttribute('stroke-linecap', 'round');
  svg.appendChild(path);

  return svg;
};
